import React from 'react';
import PropTypes from 'prop-types';
import './RoleIndicator.css';

const STUDENT_ROLES = ['Student', 'Scholar', 'Foundations'];
const PROFESSIONAL_ROLES = ['Professional', 'Legacy Backr'];
const ADMIN_ROLES = ['Admin User'];

const RoleIndicator = ({ roles = [], legacyRole = null, style = {} }) => {
  if (!legacyRole && !roles.length) {
    return null;
  }

  if (legacyRole === 'admin' || ADMIN_ROLES.some((role) => roles.some((userRole) => userRole?.name === role))) {
    return (
      <div className="admin-indicator" style={style}>
        A
      </div>
    );
  }

  if (STUDENT_ROLES.some((role) => roles.some((userRole) => userRole?.name === role))) {
    return (
      <div className="protege-indicator" style={style}>
        S
      </div>
    );
  }

  if (PROFESSIONAL_ROLES.some((role) => roles.some((userRole) => userRole?.name === role))) {
    return (
      <div className="backr-indicator" style={style}>
        B
      </div>
    );
  }

  return null;
};

RoleIndicator.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  })),
  legacyRole: PropTypes.string,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};


export default RoleIndicator;
